angular.module('bmsApp.trugreen.visitplanner').factory('VisitPlannerSvc', function ($q,
																		   CRUDSvc) {

	return {
		index: function (params) {
			return CRUDSvc.get('api/trugreen/visitplanner/read/'+ params);
		},
		calculateTravelTime: function (params) {
			return CRUDSvc.post('api/trugreen/visitplanner/calculateTravelTime', params);
		},
		workInArea: function(params) {
			return CRUDSvc.post('api/trugreen/visitplanner/workInArea', params);
		},
		save: function(params) {
			return CRUDSvc.post('api/trugreen/visitplanner/save', params);
		}
	};

});
